/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateInsuredPayloadDto
 */
export interface CreateInsuredPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof CreateInsuredPayloadDto
     */
    status: CreateInsuredPayloadDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateInsuredPayloadDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInsuredPayloadDto
     */
    longName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInsuredPayloadDto
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInsuredPayloadDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInsuredPayloadDto
     */
    postcode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInsuredPayloadDto
     */
    country: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateInsuredPayloadDto
     */
    sanctionsCompleted: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CreateInsuredPayloadDto
     */
    sanctionsCompletedDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateInsuredPayloadDto
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInsuredPayloadDto
     */
    state?: string;
}


/**
 * @export
 */
export const CreateInsuredPayloadDtoStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive'
} as const;
export type CreateInsuredPayloadDtoStatusEnum = typeof CreateInsuredPayloadDtoStatusEnum[keyof typeof CreateInsuredPayloadDtoStatusEnum];


/**
 * Check if a given object implements the CreateInsuredPayloadDto interface.
 */
export function instanceOfCreateInsuredPayloadDto(value: object): value is CreateInsuredPayloadDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('sanctionsCompleted' in value) || value['sanctionsCompleted'] === undefined) return false;
    return true;
}

export function CreateInsuredPayloadDtoFromJSON(json: any): CreateInsuredPayloadDto {
    return CreateInsuredPayloadDtoFromJSONTyped(json, false);
}

export function CreateInsuredPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateInsuredPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'name': json['name'],
        'longName': json['longName'] == null ? undefined : json['longName'],
        'address': json['address'] == null ? undefined : json['address'],
        'city': json['city'] == null ? undefined : json['city'],
        'postcode': json['postcode'] == null ? undefined : json['postcode'],
        'country': json['country'],
        'sanctionsCompleted': json['sanctionsCompleted'],
        'sanctionsCompletedDate': json['sanctionsCompletedDate'] == null ? undefined : (new Date(json['sanctionsCompletedDate'])),
        'comment': json['comment'] == null ? undefined : json['comment'],
        'state': json['state'] == null ? undefined : json['state'],
    };
}

export function CreateInsuredPayloadDtoToJSON(json: any): CreateInsuredPayloadDto {
    return CreateInsuredPayloadDtoToJSONTyped(json, false);
}

export function CreateInsuredPayloadDtoToJSONTyped(value?: CreateInsuredPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'name': value['name'],
        'longName': value['longName'],
        'address': value['address'],
        'city': value['city'],
        'postcode': value['postcode'],
        'country': value['country'],
        'sanctionsCompleted': value['sanctionsCompleted'],
        'sanctionsCompletedDate': value['sanctionsCompletedDate'] == null ? undefined : ((value['sanctionsCompletedDate']).toISOString()),
        'comment': value['comment'],
        'state': value['state'],
    };
}

